import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getServicesWhenWeHelp(tenant: Tenant): InfoCardProps[] {
	return [
		{
			title: "Trpíte nedostatkem interních IT kapacit",
		},
		{
			title: "Máte pozastavený, nebo zpožděný projekt",
		},
		{
			title: "Potřebujete narovnat firemní procesy",
		},
		{
			title: "Nevíte si rady s konkrétním IT problémem",
		},
	];
}
